import { render, staticRenderFns } from "./BlockTimeline.vue?vue&type=template&id=315ef9f3&"
import script from "./BlockTimeline.vue?vue&type=script&lang=js&"
export * from "./BlockTimeline.vue?vue&type=script&lang=js&"
import style0 from "./BlockTimeline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports